// @import dependencies
import { store } from 'app_storage/redux-storage'
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {AdminDashboardModuleLayout} from 'app_components/modules/homeScreens/adminDashboard'
// @end

// @import events
import { sidebarComponentSelected } from 'app_events/app/actions'
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IAdminDashboardModuleProps {}
interface IAdminDashboardModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class AdminDashboardModule extends Component<IAdminDashboardModuleProps, IAdminDashboardModuleState> {

  storeObject = store

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IAdminDashboardModuleProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    this.storeObject.dispatch(sidebarComponentSelected({
      component: 'admin_dashboard_sidebar'
    }))
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    this.storeObject.dispatch(sidebarComponentSelected({
      component: null
    }))
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <AdminDashboardModuleLayout
        {...this.props}
      />
    )
  }
}

export default connect(mapStatesToProps)(AdminDashboardModule)
